import { PageHeader } from "@/components/admin/PageHeader";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { siteLocation } from "@/data/location";
import { useI18n } from "@/i18n";

export function SettingsPage() {
  const { t } = useI18n();

  return (
    <div>
      <PageHeader title={t.admin.settings.title} description={t.admin.settings.description} />
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <Section title={t.admin.settings.companyProfile}>
          <Field label={t.admin.settings.dealershipName}>
            <Input defaultValue="Meridian Motors" />
          </Field>
          <Field label={t.admin.settings.tagline}>
            <Input defaultValue={t.admin.settings.taglineValue} />
          </Field>
          <Field label={t.admin.settings.about}>
            <Textarea rows={4} defaultValue={t.admin.settings.aboutValue} />
          </Field>
        </Section>
        <Section title={t.admin.settings.contact}>
          <Field label={t.admin.settings.phone}>
            <Input defaultValue={siteLocation.phoneDisplay} />
          </Field>
          <Field label={t.admin.settings.email}>
            <Input defaultValue={siteLocation.email} />
          </Field>
          <Field label={t.admin.settings.address}>
            <Input defaultValue={siteLocation.addressFull} />
          </Field>
        </Section>
        <Section title={t.admin.settings.preferences}>
          <Toggle
            label={t.admin.settings.financingCalc}
            description={t.admin.settings.financingCalcDesc}
            defaultChecked
          />
          <Toggle
            label={t.admin.settings.autoAssign}
            description={t.admin.settings.autoAssignDesc}
            defaultChecked
          />
          <Toggle
            label={t.admin.settings.whatsappTracking}
            description={t.admin.settings.whatsappTrackingDesc}
            defaultChecked
          />
          <Toggle
            label={t.admin.settings.maintenance}
            description={t.admin.settings.maintenanceDesc}
          />
        </Section>
        <Section title={t.admin.settings.team}>
          <div className="space-y-2">
            {t.admin.settings.teamMembers.map((m) => (
              <div
                key={m}
                className="flex items-center justify-between rounded-lg border border-border/60 bg-muted/20 px-3 py-2 text-sm"
              >
                <span>{m}</span>
                <span className="rounded-full bg-primary/15 px-2 py-0.5 text-[10px] font-semibold text-primary">
                  {t.admin.settings.adminBadge}
                </span>
              </div>
            ))}
          </div>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="rounded-2xl border border-border/60 bg-surface-elevated/60 p-5 backdrop-blur">
      <h3 className="mb-4 font-display text-base font-semibold">{title}</h3>
      <div className="space-y-4">{children}</div>
    </div>
  );
}
function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div>
      <Label className="mb-1.5 block text-xs font-medium text-muted-foreground">{label}</Label>
      {children}
    </div>
  );
}
function Toggle({
  label,
  description,
  defaultChecked,
}: {
  label: string;
  description: string;
  defaultChecked?: boolean;
}) {
  return (
    <div className="flex items-center justify-between gap-4 border-b border-border/40 py-2.5 last:border-0">
      <div>
        <div className="text-sm font-medium">{label}</div>
        <div className="text-xs text-muted-foreground">{description}</div>
      </div>
      <Switch defaultChecked={defaultChecked} />
    </div>
  );
}
